/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'priority': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M790.3 385H591.2l128.4-276.1c6.4-19.3-12.8-45-32.1-45H430.7c-12.8 0-25.7 6.4-32.1 19.3L205.9 596.9c-6.4 25.7 12.8 44.9 32.1 44.9h224.8l-64.2 289v6.4c0 12.8 12.8 25.7 25.7 25.7 6.4 0 19.3-6.4 19.3-12.8L816 436.3c12.8-25.7 0-51.3-25.7-51.3zm0 0" _fill="#f4ea2a"/>'
  }
})
